import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import styles from "./pageHero.module.css";
import { Button } from "../UI";
import TextReveal, { revealDuration } from "../ANIMATION/TextReveal";
import { EASE } from "../../UTILS/ANIMATION/motionVariants";

const PageHero = ({ eyebrow, title, lead, actions = [], image, imageAlt, imagePosition, note, id }) => {
  const reduce = useReducedMotion();
  // Eyebrow, then the title word by word, then everything else in order
  // once the title has landed.
  const TITLE_DELAY = 0.2;
  // titles arrive as <>text <em>accent</em></>; reveal the fragment's contents
  const titleContent = title && title.type === React.Fragment ? title.props.children : title;
  const after = revealDuration(titleContent, TITLE_DELAY) - 0.3;
  const item = (i) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 24 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.75, delay: i === 0 ? 0.05 : after + (i - 2) * 0.12, ease: EASE },
        };

  return (
    <section className={styles.hero} aria-labelledby={id}>
      <div className={styles.inner}>
        <div className={styles.copy}>
          {eyebrow && (
            <motion.p className={styles.eyebrow} {...item(0)}>
              {eyebrow}
            </motion.p>
          )}
          <TextReveal as="h1" id={id} className={styles.title} delay={TITLE_DELAY} onLoad>
            {titleContent}
          </TextReveal>
          {lead && (
            <motion.p className={styles.lead} {...item(2)}>
              {lead}
            </motion.p>
          )}
          {actions.length > 0 && (
            <motion.div className={styles.actions} {...item(3)}>
              {actions.map((a, i) => (
                <Button
                  key={a.href}
                  href={a.href}
                  variant={i === 0 ? "primary" : "secondary"}
                  tone="dark"
                >
                  {a.label}
                </Button>
              ))}
            </motion.div>
          )}
          {note && (
            <motion.div className={styles.note} {...item(4)}>
              {note}
            </motion.div>
          )}
        </div>
        <div className={styles.visual}>
          <span className={styles.arc} aria-hidden="true" />
          <img
            className={styles.photo}
            src={image}
            alt={imageAlt}
            style={imagePosition ? { objectPosition: imagePosition } : undefined}
            fetchpriority="high"
          />
        </div>
      </div>
    </section>
  );
};

export default PageHero;
